import { render, staticRenderFns } from "./RelatorioInformativoPagAtual.vue?vue&type=template&id=efa92a32&scoped=true&"
import script from "./RelatorioInformativoPagAtual.vue?vue&type=script&lang=js&"
export * from "./RelatorioInformativoPagAtual.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioInformativoPagAtual.vue?vue&type=style&index=0&id=efa92a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa92a32",
  null
  
)

export default component.exports